module.exports = __webpack_public_path__ + "img/256x256_diamond_partial_warp_gate.40ff86e8.svg";